var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSmallcaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.87 3.05C18.92 2.36 17.68 2 16.19 2H7.81c-.2 0-.4.01-.59.03C3.94 2.24 2 4.37 2 7.81v8.38c0 1.49.36 2.73 1.05 3.68.29.42.66.79 1.08 1.08.82.6 1.86.95 3.09 1.03.19.01.39.02.59.02h8.38c3.64 0 5.81-2.17 5.81-5.81V7.81c0-1.49-.36-2.73-1.05-3.68-.29-.42-.66-.79-1.08-1.08zM8.52 15.88c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1V7.91H6.95a.2.2 0 0 0-.2.2v.78c0 .41-.34.74-.75.74s-.75-.33-.75-.75V8.1c0-.94.76-1.7 1.7-1.7h6.64c.94 0 1.7.76 1.7 1.7v.78c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8.1a.2.2 0 0 0-.2-.2h-2.57v6.48h.37c.41 0 .75.34.75.75s-.34.75-.75.75H8.52zm9.48-2.9c-.41 0-.75-.34-.75-.75v-.33H15.7v4.2h.35c.41 0 .75.34.75.75s-.34.75-.75.75h-2.2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.35v-4.2h-.48c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.6c.79 0 1.43.64 1.43 1.43v.4c0 .41-.34.75-.75.75z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSmallcaps);
export default __webpack_public_path__ + "static/media/vuesax-bold-smallcaps.ad9b4195a66adb72490a8b2ed5a75530.svg";
export { ForwardRef as ReactComponent };